import { prepagaContacto } from './bff/bffClient';
import { mapTipoDocumento } from './bff/bffMappers';

type ContactoPrepagoParams = {
    compania?: string;
    origen?: string;
    tipoCotizador?: string;
    landingUrl?: string;
    refererUrl?: string;
    tipoDoc?: string;
    cuit?: string;
    numeroDoc?: string;
    razonSocial?: string;
    empleados?: number;
    nombre?: string;
    apellido?: string;
    codigoArea?: string;
    telefono?: string;
    email?: string;
    provincia?: string;
    localidad?: string;
    FechaNacimiento?: { dia: string; mes: string; año: string },
    DerivaAportes?: boolean,
    Conyuge?: boolean,
    SueldoBruto?: number,
    Observaciones?: string,
    DocumentoConyuge?: string,
    UnificaAportes?: boolean,
    SueldoBrutoConyuge?: number
    CantidadHijos?: number
    captchaToken?: string;
};

const toNum = (v: unknown): number => {
    const n = Number(v);
    return Number.isFinite(n) ? n : 0;
};

/**
 * Construye el DTO EXACTO que espera el BFF en POST /prepaga/contacto
 * (CotizacionPrepagaDTO: Telefono plano + CodigoArea separado, TipoDocumento
 * como nombre de miembro C#, FechaNacimiento dd/MM/yyyy, sumas number). Ver bffMappers.ts.
 */
export const buildCotizacionPrepagaDTO = (params: ContactoPrepagoParams) => {
    const esEmpresa = params.tipoDoc?.toLowerCase() === 'cuit';
    return {
        Compania: params.compania ?? 'PREPAGA',
        Nombre: params.nombre ?? null,
        Apellido: params.apellido ?? null,
        TipoDocumento: mapTipoDocumento(params.tipoDoc),
        // Persona física: numeroDoc. Empresa (CUIT): el documento es el CUIT.
        NumeroDocumento: esEmpresa ? (params.cuit ?? null) : (params.numeroDoc ?? null),
        CUIT: params.cuit ?? null,
        RazonSocial: params.razonSocial ?? null,
        CantidadEmpleados: toNum(params.empleados),
        // Telefono PLANO (solo número) + CodigoArea separado.
        Telefono: params.telefono ?? '',
        CodigoArea: params.codigoArea ?? '',
        Email: params.email ?? '',
        FechaNacimiento: params.FechaNacimiento
            ? `${params.FechaNacimiento.dia}/${params.FechaNacimiento.mes}/${params.FechaNacimiento.año}`
            : null,
        Provincia: params.provincia ?? '',
        Localidad: params.localidad ?? '',
        CantidadHijos: toNum(params.CantidadHijos),
        Observaciones: params.Observaciones ?? null,
        SueldoBruto: toNum(params.SueldoBruto),
        IncluirConyuge: params.Conyuge ?? false,
        NumeroDocumentoConyuge: params.DocumentoConyuge ?? null,
        UnificarSueldos: params.UnificaAportes ?? false,
        SueldoBrutoConyuge: toNum(params.SueldoBrutoConyuge),
        RefererUrl: params.landingUrl ?? params.refererUrl ?? null,
        LandingUrl: typeof document !== 'undefined' ? document.location.href : undefined,
    };
};

/**
 * Paso 1 Prepaga: guarda el contacto vía el BFF (POST {BFF}/prepaga/contacto).
 * El recaptcha lo mintea el bffClient (header `g-recaptcha-response`); el `captchaToken`
 * de params ya no se envía en el body. Adapta la respuesta del BFF
 * ({ idContacto, token }) al envelope { data: { api_status, api_data } } que consume Precios.
 */
const guardarContactoPrepaga = async (params: ContactoPrepagoParams): Promise<any> => {
    const cotizacion = buildCotizacionPrepagaDTO(params);

    try {
        const apiData = await prepagaContacto(cotizacion);
        return { data: { api_status: 200, api_data: apiData } };
    } catch (error) {
        return error;
    }
};

export default guardarContactoPrepaga;
